import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// images from public folder
const GreenTick = `${process.env.PUBLIC_URL}/assets/greenTick.webp`;

const Features = [
  {
    id: 0,
    title: "Real-time Collaboration",
    desc: "Work together seamlessly with live updates and instant synchronization across your team.",
    image: "https://i.ibb.co/KzcDjCD8/realtime.gif",
  },
  {
    id: 1,
    title: "Unique Department Colours",
    desc: "Organize and identify departments instantly with customizable color coding for better workflow management.",
    image: "https://i.ibb.co/QFc0pmVF/department.png",
  },
  {
    id: 2,
    title: "User Management",
    desc: "Control access and permissions with comprehensive user management tools for enhanced security.",
    image: "https://i.ibb.co/QsSM962/user-management.png",
  },
  {
    id: 3,
    title: "Online/Offline Status",
    desc: "Track team availability in real-time with instant online and offline status indicators.",
    image: "https://i.ibb.co/8LdWJz0t/Whats-App-Image-2025-12-16-at-4-34-53-PM.jpg",
  },
];

const HomeAbout = () => {
  const navigate = useNavigate();
  const [hoveredFeature, setHoveredFeature] = useState(0); // Default to first feature

  const handleButtonClick = (params) => {
    navigate("/signup");
  };
  return (
    <div
      id="about"
      className="min-h-screen bg-[#F1F1FF] px-4 md:px-8 lg:px-16 py-16 md:py-24 text-center md:text-left font-tahoma font-[400] text-[#273720]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col justify-center items-center mb-12 md:mb-16 space-y-4">
          <h5 className="text-sm md:text-base font-semibold text-[#5E5ADB] uppercase tracking-wider">
            OTHER FEATURES
          </h5>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold max-w-3xl text-[#273720]">
            Features at a glance
          </h1>
        </div>

        <div className="flex flex-col lg:flex-row justify-between items-start gap-8 lg:gap-12">
          {/* Feature Buttons Section */}
          <div className="w-full lg:w-1/2 space-y-4 py-8">
            {Features.map((feature) => (
              <button
                key={feature.id}
                onMouseEnter={() => setHoveredFeature(feature.id)}
                onMouseLeave={() => setHoveredFeature(0)}
                className={`w-full bg-white/80 backdrop-blur-sm rounded-xl p-5 md:p-6 shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 border-2 text-left ${
                  hoveredFeature === feature.id
                    ? "border-[#5E5ADB] shadow-2xl scale-105 bg-[#5E5ADB]/5"
                    : "border-[#E5E5FF] hover:border-[#5E5ADB]/40"
                }`}
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 mt-1">
                    <img
                      src={GreenTick}
                      alt=""
                      className="bg-white rounded-full p-1 w-6 h-6 md:w-7 md:h-7 shadow-sm"
                    />
                  </div>
                  <div className="flex-1">
                    <h5 className={`text-base md:text-lg font-bold mb-2 transition-colors ${
                      hoveredFeature === feature.id ? "text-[#5E5ADB]" : "text-[#131149]"
                    }`}>
                      {feature.title}
                    </h5>
                    <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                      {feature.desc}
                    </p>
                  </div>
                </div>
              </button>
            ))}

            <button
              onClick={handleButtonClick}
              className="bg-gradient-to-r from-[#5E5ADB] to-[#7B6FE8] hover:from-[#4E4ACB] hover:to-[#6B5FD8] text-white rounded-xl py-3 px-6 md:py-3.5 md:px-8 text-sm md:text-base font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 w-full mt-8"
            >
              Get Started
            </button>
          </div>

          {/* Image Display Section */}
          <div className="w-full lg:w-1/2 relative flex justify-center lg:justify-end items-center min-h-[400px] md:min-h-[500px]">
            <div className="relative w-full max-w-lg">
              <div className="relative transition-all duration-500 ease-in-out">
                <div className="absolute inset-0 bg-gradient-to-br from-[#C8C6FF]/30 to-[#5E5ADB]/20 rounded-3xl blur-2xl transform rotate-3"></div>
                <img
                  src={Features[hoveredFeature].image}
                  alt={Features[hoveredFeature].title}
                  className="relative w-full h-auto max-h-[500px] object-contain rounded-2xl shadow-2xl transform transition-all duration-500 hover:scale-105 z-10"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeAbout;
